<template>
    <div class="select-email-accounts-component" :class="appendClass">
        <a-select
                show-search
                option-filter-prop="children"
                style="display: block;"
                :placeholder="placeholder"
                :mode="mode"
                :disabled="disabled"
                :value="internalValue"
                :filter-option="filterOption"
                @focus="handleFocus"
                @blur="handleBlur"
                @change="handleChange"
        >
            <a-select-option v-if="canDeselect" value="">
              Selecteer een email account
            </a-select-option>
            <a-select-option v-for="account in emailAccounts" :key="account.id" :value="account.id">
                {{ label(account) }}
            </a-select-option>
        </a-select>
        <input v-if="multiple" type="hidden" :name="fieldName" v-for="account in internalValue" :value="account"/>
        <input v-else type="hidden" :name="fieldName" :value="internalValue"/>
    </div>
</template>

<script>
import store from '../store'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'SelectEmailAccountsComponent',
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    value: {
      type: [Array, Number, String],
      default: () => ([])
    },
    appendClass: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canDeselect: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      internalValue: null,
    }
  },
  computed: {
    ...mapGetters({
      emailAccounts: '$_email_account/emailAccounts',
      hasEmailAccounts: '$_email_account/emailAccounts',
    }),
    mode () {
      return this.multiple ? 'multiple' : null
    },
    placeholder () {
      return this.multiple ? 'Selecteer email accounts' : 'Selecteer een email account'
    },
  },
  created () {
    const STORE_KEY = '$_email_account'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    this.fetchEmailAccounts()

    this.internalValue = this.value
  },
  methods: {
    ...mapActions({
      fetchEmailAccounts: '$_email_account/fetchEmailAccounts',
    }),
    handleChange (values) {
      this.internalValue = values
      this.$emit('change', values)
      this.$emit('input', values)
    },
    handleBlur () {
      this.$emit('blur')
    },
    handleFocus () {
      this.$emit('focus')
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    label (account) {
      return `${account.name} (${account.address})`
    }
  },
  watch: {
    value () {
      this.internalValue = this.value
    }
  }
}
</script>

<style scoped>

</style>
